import { Fancybox } from "@fancyapps/ui";

(function($) {
  $(function() {
    if($('.svg-map').length > 0) {
      $('.svg-map').each(function() {
        initMap($(this));
      });
    }
  });

  function initMap($wrapper) {
    var $markers = $wrapper.find('.svg-map__map .svg-map__link');
    var $fancyboxTriggers = $wrapper.find('.svg-map__map .svg-map__fancybox');
    var $descriptions = $wrapper.find('.svg-map__description');
    var clickScroll = $wrapper.data('svg-map-scroll') == true;

    setActive($markers.first(), $markers, $descriptions, false);

    $markers.click(function() {
      setActive($(this), $markers, $descriptions, clickScroll);
    });

    $fancyboxTriggers.click(function() {
      openFancybox($(this), $descriptions);
    });
  }

  function setActive($marker, $markers, $descriptions, clickScroll) {
    var id = $marker.attr('id');
    var $description = $descriptions.filter('[data-svg-id="' + id + '"]');
    $('.rental-area__content').addClass('rental-area__content--fade');
    setTimeout(function() {
      $('.rental-area__content').removeClass('rental-area__content--fade');
      $descriptions.hide();
      $description.show();
    }, 200);
    
    
    $markers.removeClass('active');
    $marker.addClass('active');

    if(clickScroll && $(window).width() <= window.ScreenSM) {
      scrollToEl($descriptions.first().parent());
    }
  }

  function openFancybox($marker, $descriptions) {
    var id = $marker.attr('id').replace('-fancybox', '');
    var $description = $descriptions.filter('[data-svg-id="' + id + '"]');
    var fancyBoxUrl = $description.data('fancybox-url');
    if(fancyBoxUrl) {
      Fancybox.show([
        {
          src: fancyBoxUrl,
          type: "iframe",
          preload: false,
          width: 1000,
          height: 700,
        },
      ]);
    }
  }
})(jQuery);
